import React from 'react'
import {SimpleMenuItem} from './item'

export interface MenuOption<T> {
  key?: string
  label: string
  value: T
  icon?: React.ReactElement
  count?: string
  disabled?: boolean
}

export interface MenuProps<T> {
  options: MenuOption<T>[]
  value: T | T[]
  onChange: (value: T | T[]) => void
  multiple?: boolean
  keyAccessor?: (option: MenuOption<T>) => string
}

const DefaultKeyAccessor = <T,>(option: MenuOption<T>) => {
  if (option.key === undefined) {
    return option.label
  }
  return option.key
}

export const SharedMenu = <T,>({
  options,
  value,
  onChange,
  multiple = false,
  keyAccessor = DefaultKeyAccessor
}: MenuProps<T>) => {
  const isSelected = (option: MenuOption<T>): boolean => {
    if (multiple) {
      return Array.isArray(value) && value.includes(option.value)
    } else {
      return option.value === value
    }
  }

  const handleClick = (option: MenuOption<T>) => {
    if (multiple) {
      let newValue: T[]
      if (Array.isArray(value) && value.includes(option.value)) {
        newValue = value.filter(v => v !== option.value)
      } else {
        newValue = Array.isArray(value)
          ? [...value, option.value]
          : [option.value]
      }
      onChange(newValue)
    } else {
      if (option.value !== value) {
        onChange(option.value)
      }
    }
  }

  return (
    <div>
      {options.map(option => (
        <SimpleMenuItem
          key={keyAccessor(option)}
          label={option.label}
          icon={option.icon}
          count={option.count}
          selected={isSelected(option)}
          onClick={() => handleClick(option)}
          disabled={option.disabled}
        />
      ))}
    </div>
  )
}
